<div class="p-4 md:p-8" style="max-width: 520px; margin: 0 auto;">

  <!-- Header -->
  <div style="display: flex; align-items: center; justify-content: center; gap: 10px; margin-bottom: 24px;">
    <mat-icon style="font-size: 28px; width: 28px; height: 28px; color: #1C593D;">swap_horiz</mat-icon>
    <h1 style="font-size: 1.3rem; font-weight: 800; color: #1e5a3f; margin: 0;">Convertir USDT a CLP</h1>
  </div>

    <!-- Rate + Balance Card -->
    <div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; overflow: hidden; margin-bottom: 20px;">
      <!-- Rate header -->
      <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0; text-align: center;">
        <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Tipo de cambio</span>
        <div style="display: flex; flex-wrap: wrap; align-items: center; justify-content: center; gap: 8px; margin-top: 6px;">
          <img src="assets/icons/USDT_Logo.png" alt="USDT" style="width: 24px; height: 24px; border-radius: 50%; object-fit: cover;">
          <span style="font-size: 1.3rem; font-weight: 800; color: #1e5a3f; white-space: nowrap;">1 USDT =</span>
          <span style="font-size: 1.3rem; font-weight: 800; color: #1e5a3f; white-space: nowrap;">{{ formatCLP(tasaAplicada || usdtToClpRate || 0) }} CLP</span>
          <img src="assets/flags/chile.png" alt="CLP" style="width: 24px; height: 24px; border-radius: 50%; object-fit: cover;">
        </div>
        <!-- Tramos USDT→CLP: la mejor tasa publicada. En la venta la mejor es
             la MAYOR, así que es «Hasta X» (como en la landing), no «Desde». -->
        <p *ngIf="desdeTasa" class="tramo-desde" [class.tramo-desde--escalera]="!!escaleraUsdtClp" style="margin: 6px 0 0; font-size: 0.78rem; font-weight: 600; color: #166534; overflow-wrap: anywhere;">
          Hasta {{ formatCLP(desdeTasa) }} CLP por USDT según el monto
        </p>
      </div>

      <!-- Balances -->
      <div class="grid grid-cols-1 sm:grid-cols-2" style="padding: 0;">
        <div style="padding: 14px 24px; text-align: center; border-bottom: 1px solid #e5e7eb;"
          class="sm:border-r sm:border-gray-200">
          <div style="display: flex; align-items: center; justify-content: center; gap: 6px;">
            <img src="assets/icons/USDT_Logo.png" alt="USDT" style="width: 18px; height: 18px; border-radius: 50%; object-fit: cover;">
            <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase;">Saldo USDT</span>
          </div>
          <p style="font-size: 1.1rem; font-weight: 700; color: #1e5a3f; margin: 2px 0 0;">
            {{ formatUSDTWithSymbol(saldoUsdt) }}
          </p>
        </div>
        <div style="padding: 14px 24px; text-align: center;">
          <div style="display: flex; align-items: center; justify-content: center; gap: 6px;">
            <img src="assets/flags/chile.png" alt="CLP" style="width: 18px; height: 18px; border-radius: 50%; object-fit: cover;">
            <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase;">Saldo CLP</span>
          </div>
          <p style="font-size: 1.1rem; font-weight: 700; color: #1e5a3f; margin: 2px 0 0;">
            {{ formatCLP(saldoClp) }} CLP
          </p>
        </div>
      </div>

      <!-- Operating hours -->
      <div style="padding: 10px 24px; border-top: 1px solid #e5e7eb; text-align: center;"
        [style.background]="!isOperatingHours ? '#fef2f2' : '#fafafa'">
        <span style="font-size: 0.78rem; font-weight: 500;"
          [style.color]="!isOperatingHours ? '#dc2626' : '#6b7280'">
          Horario de operación: <strong>{{ horarioOperacion }}</strong>
          <span *ngIf="!isOperatingHours" style="font-weight: 700; color: #dc2626;"> — CERRADO</span>
        </span>
      </div>
    </div>

    <!-- Calculator Card -->
    <div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; overflow: hidden; margin-bottom: 20px;">
      <div style="padding: 24px;">

        <!-- USDT Input -->
        <div style="margin-bottom: 20px;">
          <label style="display: flex; align-items: center; gap: 6px; font-size: 0.8rem; font-weight: 600; color: #1e5a3f; margin-bottom: 6px;">
            <img src="assets/icons/USDT_Logo.png" alt="USDT" style="width: 18px; height: 18px; border-radius: 50%; object-fit: cover;">
            Cantidad USDT a enviar
          </label>
          <div style="position: relative;">
            <span style="position: absolute; left: 16px; top: 50%; transform: translateY(-50%); color: #1e5a3f; font-weight: 700; font-size: 0.85rem; pointer-events: none; z-index: 2; display: flex; align-items: center; gap: 4px;">
              <img src="assets/icons/USDT_Logo.png" alt="USDT" style="width: 16px; height: 16px; border-radius: 50%; object-fit: cover;">
              USDT
            </span>
            <!-- `type=text` + `appMonto`: separador de miles en vivo. La
                 directiva ya filtra dígitos, acota los decimales y sanea lo
                 pegado, así que el `keydown` manual y el bloqueo de pegar
                 sobran — y peor: con miles, `allowDecimalInput` veía la coma
                 del separador y bloqueaba el punto decimal. -->
            <input type="text" inputmode="numeric" appMonto [decimales]="2"
              [(ngModel)]="montoAConvertir"
              (ngModelChange)="calcularConversion()"
              placeholder="0"
              [disabled]="!isOperatingHours"
              class="calc-input"
              style="width: 100%; padding: 14px 80px 14px 75px; border: 2px solid #e5e7eb; border-radius: 12px; font-size: 1.1rem; font-weight: 700; color: #1e5a3f; background: white; text-align: right; outline: none; box-sizing: border-box; transition: border-color 0.2s;"
              onfocus="this.style.borderColor='#34d399'" onblur="this.style.borderColor='#e5e7eb'">
            <button type="button" class="btn-tactil"
              [class.disabled]="!isOperatingHours"
              [disabled]="!isOperatingHours"
              (click)="isOperatingHours && (montoAConvertir = saldoUsdt) && calcularConversion()"
              style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); background: #1C593D; color: white; border: none; border-radius: 8px; padding: 4px 12px; font-size: 0.75rem; font-weight: 700; cursor: pointer; transition: background 0.2s;"
              onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
              MÁX.
            </button>
          </div>
        </div>

        <!-- Arrow separator -->
        <div style="display: flex; justify-content: center; margin-bottom: 16px;">
          <div style="width: 36px; height: 36px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 50%; display: flex; align-items: center; justify-content: center;">
            <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">arrow_downward</mat-icon>
          </div>
        </div>

        <!-- CLP Output -->
        <div style="margin-bottom: 8px;">
          <label style="display: flex; align-items: center; gap: 6px; font-size: 0.8rem; font-weight: 600; color: #1e5a3f; margin-bottom: 6px;">
            <img src="assets/flags/chile.png" alt="CLP" style="width: 18px; height: 18px; border-radius: 50%; object-fit: cover;">
            Cantidad que recibes en CLP
          </label>
          <div style="position: relative;">
            <span style="position: absolute; left: 16px; top: 50%; transform: translateY(-50%); color: #1e5a3f; font-weight: 700; font-size: 0.85rem; pointer-events: none; z-index: 2; display: flex; align-items: center; gap: 4px;">
              <img src="assets/flags/chile.png" alt="CLP" style="width: 16px; height: 16px; border-radius: 50%; object-fit: cover;">
              CLP
            </span>
            <input type="text"
              [value]="formatCLP(montoConvertido)"
              readonly
              placeholder="0"
              style="width: 100%; padding: 14px 16px 14px 70px; border: 2px solid #e5e7eb; border-radius: 12px; font-size: 1.1rem; font-weight: 700; color: #1e5a3f; background: #f9fafb; text-align: right; outline: none; box-sizing: border-box;">
          </div>
          <!-- Tramos USDT→CLP: lo que gana con este monto frente a la base
               (con escalera lo dice `app-escalera-tramos`, abajo) -->
          <p *ngIf="extraClp > 0 && !escaleraUsdtClp" class="tramo-extra" role="status"
            style="display: inline-block; max-width: 100%; overflow-wrap: anywhere; margin: 8px 0 0; padding: 2px 10px; border-radius: 999px; background: #dcfce7; font-size: 0.78rem; font-weight: 700; color: #166534;">
            Con este monto recibes {{ formatCLP(extraClp) }} más
          </p>
        </div>

        <!-- Escalera de tramos: «Tu tasa», «Tramo k de N», lo que recibe de
             más, lo que falta y la lista plegada. Sin escalera no se dibuja.
             En el celular acá va solo el teaser de una línea; la completa,
             debajo del botón. Formato en-US, el del campo de monto. -->
        <app-escalera-tramos
          *ngIf="usdtToClpRate && escaleraUsdtClp as esc"
          class="usdt-clp-escalera usdt-clp-escalera--arriba"
          posicion="arriba"
          locale="en-US"
          [escalera]="esc"
          [monto]="montoAConvertir"
          moneda="USDT"
          monedaDestino="CLP"
          tipoAhorro="RECIBE_MAS"
          decimales="1.2-2"
          [tasaAplicada]="tasaAplicada"
          [tasaReferencia]="usdtToClpRate"
          simbolo="CLP"
          unidad="CLP por 1 USDT"
          idBase="esc-usdt-clp"
          [compacta]="true"
          [permitirUsar]="isOperatingHours"
          [montoMaximo]="saldoUsdt"
          (usarMonto)="usarMontoUsdt($event)"
        ></app-escalera-tramos>
      </div>
    </div>

    <!-- Beneficiary Card (solo VE) -->
    <div *ngIf="isVeUser" style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; overflow: hidden; margin-bottom: 20px;">
      <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 14px 24px; border-bottom: 2px solid #bbf7d0; display: flex; align-items: center; justify-content: space-between;">
        <div style="display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 22px; width: 22px; height: 22px; color: #1C593D;">account_balance</mat-icon>
          <span style="font-size: 0.9rem; font-weight: 800; color: #1e5a3f;">Beneficiario en Chile</span>
        </div>
        <button type="button" (click)="openAddBeneficiaryDialog()"
          style="display: inline-flex; align-items: center; gap: 4px; padding: 5px 14px; background: #1C593D; color: white; border: none; border-radius: 8px; font-size: 0.72rem; font-weight: 700; cursor: pointer; transition: background 0.2s;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;">add</mat-icon>
          Nuevo
        </button>
      </div>

      <div style="padding: 16px 24px;">
        <!-- Buscador -->
        <div *ngIf="beneficiaries.length > 3" style="margin-bottom: 12px;">
          <input type="text" [(ngModel)]="searchTerm" placeholder="Buscar beneficiario..."
            style="width: 100%; padding: 10px 14px; border: 2px solid #e5e7eb; border-radius: 10px; font-size: 0.85rem; color: #374151; background: white; outline: none; box-sizing: border-box; transition: border-color 0.2s;"
            onfocus="this.style.borderColor='#34d399'" onblur="this.style.borderColor='#e5e7eb'">
        </div>

        <!-- Loading -->
        <div *ngIf="loadingBeneficiarios" style="text-align: center; padding: 20px 0;">
          <mat-icon style="font-size: 24px; width: 24px; height: 24px; color: #1C593D; animation: spin 1s linear infinite;">sync</mat-icon>
          <p style="font-size: 0.8rem; color: #6b7280; margin: 8px 0 0;">Cargando beneficiarios...</p>
        </div>

        <!-- Sin beneficiarios -->
        <div *ngIf="!loadingBeneficiarios && beneficiaries.length === 0" style="text-align: center; padding: 20px 0;">
          <mat-icon style="font-size: 40px; width: 40px; height: 40px; color: #d1d5db;">account_balance</mat-icon>
          <p style="font-size: 0.85rem; color: #6b7280; margin: 8px 0 4px;">No tienes cuentas chilenas registradas</p>
          <p style="font-size: 0.75rem; color: #9ca3af; margin: 0;">Agrega una cuenta de retiro CLP para poder convertir.</p>
        </div>

        <!-- Lista de beneficiarios -->
        <div *ngIf="!loadingBeneficiarios && beneficiaries.length > 0"
          style="max-height: 220px; overflow-y: auto; display: flex; flex-direction: column; gap: 8px;">
          <div *ngFor="let b of filteredBeneficiaries"
            (click)="selectBeneficiary(b)"
            [style.border]="selectedBeneficiary?.id === b.id ? '2px solid #34d399' : '2px solid #e5e7eb'"
            [style.background]="selectedBeneficiary?.id === b.id ? '#f0fdf4' : 'white'"
            style="padding: 12px 16px; border-radius: 12px; cursor: pointer; transition: all 0.2s ease; display: flex; align-items: center; gap: 12px;">
            <div
              [style.background]="selectedBeneficiary?.id === b.id ? '#1C593D' : '#f3f4f6'"
              style="width: 36px; height: 36px; border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
              <span
                [style.color]="selectedBeneficiary?.id === b.id ? 'white' : '#6b7280'"
                style="font-size: 0.85rem; font-weight: 700;">{{ (b.alias || b.banco || 'C').charAt(0) }}</span>
            </div>
            <div style="flex: 1; min-width: 0;">
              <p style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f; margin: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                {{ b.alias || 'Cuenta ' + b.numeroCuenta }}
              </p>
              <p style="font-size: 0.72rem; color: #6b7280; margin: 2px 0 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                {{ b.banco }} — {{ b.numeroCuenta }} · {{ b.tipoCuenta }}
              </p>
            </div>
            <mat-icon *ngIf="selectedBeneficiary?.id === b.id"
              style="font-size: 20px; width: 20px; height: 20px; color: #1C593D; flex-shrink: 0;">check_circle</mat-icon>
          </div>

          <!-- Sin resultados de búsqueda -->
          <div *ngIf="filteredBeneficiaries.length === 0 && searchTerm" style="text-align: center; padding: 12px 0;">
            <p style="font-size: 0.8rem; color: #6b7280; margin: 0;">No se encontraron resultados para "{{ searchTerm }}"</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Validation / Error Messages -->
    <div *ngIf="!errorMessage && validationMessage"
      style="margin-bottom: 16px; padding: 10px 16px; background: #fef3c7; border: 1px solid #fde68a; border-left: 4px solid #f59e0b; border-radius: 10px; display: flex; align-items: center; gap: 8px;">
      <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #f59e0b;">warning</mat-icon>
      <span style="font-size: 0.8rem; font-weight: 600; color: #92400e;">{{ validationMessage }}</span>
    </div>

    <div *ngIf="errorMessage"
      style="margin-bottom: 16px; padding: 10px 16px; background: #fef2f2; border: 1px solid #fecaca; border-left: 4px solid #dc2626; border-radius: 10px; display: flex; align-items: center; gap: 8px;">
      <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #dc2626;">error</mat-icon>
      <span style="font-size: 0.8rem; font-weight: 600; color: #991b1b;">{{ errorMessage }}</span>
    </div>

    <div *ngIf="rateChanged"
      style="margin-bottom: 16px; padding: 10px 16px; background: #eff6ff; border: 1px solid #bfdbfe; border-left: 4px solid #2563eb; border-radius: 10px; display: flex; align-items: center; gap: 8px;">
      <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #2563eb;">info</mat-icon>
      <span style="font-size: 0.8rem; font-weight: 600; color: #1e40af;">¡La tasa de cambio se ha actualizado!</span>
    </div>

    <!-- Action Buttons -->
    <div style="display: flex; gap: 12px; justify-content: center; flex-wrap: wrap;">
      <button type="button" (click)="navigateBack()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 28px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">arrow_back</mat-icon>
        Volver
      </button>
      <button type="button" (click)="realizarCompra()"
        [disabled]="!showComprarButton || isConverting"
        [style.opacity]="(!showComprarButton || isConverting) ? '0.5' : '1'"
        [style.cursor]="(!showComprarButton || isConverting) ? 'not-allowed' : 'pointer'"
        style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">{{ isConverting ? 'hourglass_top' : 'sync_alt' }}</mat-icon>
        {{ isConverting ? 'Procesando...' : 'Convertir' }}
      </button>
    </div>

    <!-- Celular (bajo 768 px): la escalera completa, debajo del botón. -->
    <app-escalera-tramos
      *ngIf="usdtToClpRate && escaleraUsdtClp as esc"
      class="usdt-clp-escalera"
      posicion="abajo"
      locale="en-US"
      [escalera]="esc"
      [monto]="montoAConvertir"
      moneda="USDT"
      monedaDestino="CLP"
      tipoAhorro="RECIBE_MAS"
      decimales="1.2-2"
      [tasaAplicada]="tasaAplicada"
      [tasaReferencia]="usdtToClpRate"
      simbolo="CLP"
      unidad="CLP por 1 USDT"
      idBase="esc-usdt-clp"
      [compacta]="true"
      [permitirUsar]="isOperatingHours"
      [montoMaximo]="saldoUsdt"
      (usarMonto)="usarMontoUsdt($event)"
    ></app-escalera-tramos>

</div>
